<template>
  <v-app>
    <TopNavbar
      v-if="
        browserSize.md === true ||
        browserSize.lg === true ||
        browserSize.xl === true
      "
    />
    <Navbar />
    <v-main transition="slide-x-transition">
      <router-view></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import TopNavbar from "./components/TopNavbar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default {
  name: "App",

  components: {
    TopNavbar,
    Navbar,
    Footer,
  },

  data: () => ({
    //
  }),
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>
